import "./style.css";

const Footer = () => {
  return (
    <footer>
      <a href="https://www.facebook.com/shani.levi3/photos" target="_blank">
        <img
          src="https://github.com/DwinaTech/public-images/blob/main/facebook-con.png?raw=true"
          alt="YouTube-icon"
        />
      </a>
      <a
        href="https://www.linkedin.com/in/shani-levi-244455209/"
        target="_blank"
      >
        <img
          src="https://github.com/DwinaTech/public-images/blob/main/linkedin-icon.png?raw=true"
          alt="LinkIn-icon"
        />
      </a>
    </footer>
  );
};

export default Footer;
